<script>
  import Constant from "./Constant";
  export let commentLogs;

  const getColor = (color) => {
    return Constant.COLORS[Number(color)].code;
  };
</script>

<div class="logs">
  {#each commentLogs as commentLog}
    <div class="row">
      {#if commentLog.type == Constant.COMMENT_TYPE.JOIN}
        <span class="joinLeaveName">{commentLog.name}</span>
        <span class="comment">さんが入室しました。</span>
        <span class="date">({commentLog.created_at})</span>
      {:else if commentLog.type == Constant.COMMENT_TYPE.LEAVE}
        <span class="joinLeaveName">{commentLog.name}</span>
        <span class="comment">さんが退室しました。</span>
        <span class="date">({commentLog.created_at})</span>
      {:else}
        <span class="name" style="color:{getColor(commentLog.color)};">
          {commentLog.name}
        </span>
        <span class="comment" style="color:{getColor(commentLog.color)};">
          {commentLog.comment}
        </span>
        <span class="date">({commentLog.created_at})</span>
      {/if}
    </div>
    <hr />
  {/each}
</div>

<style>
  .logs {
    display: flex;
    flex-direction: column;
    padding: 5px 10px;
    max-height: calc(100% - 210px);
    overflow-y: auto;
  }
  .row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-bottom: 3px;
    align-items: center;
  }

  .joinLeaveName {
    margin-right: 3px;
    font-weight: bold;
  }
  .name {
    margin-right: 3px;
    font-weight: bold;
    flex-shrink: 1;
  }
  .name::after {
    font-weight: normal;
    margin-left: 5px;
    content: "＞";
  }
  .comment {
    margin-right: 5px;
    flex-shrink: 1;
  }
  .date {
    font-size: 0.9rem;
    color: rgb(160, 160, 160);
    flex-shrink: 1;
  }
</style>
